function cloneJson(value) {
  if (typeof value === 'undefined') return undefined;
  return JSON.parse(JSON.stringify(value));
}

var LEGACY_FIELD_ALIASES = [
  { legacyName: 'designAirflowCfm', name: 'designAirflow', kind: 'air_flow', defaultUnit: 'ft3/m' },
  { legacyName: 'minimumAirflowCfm', name: 'minimumAirflow', kind: 'air_flow', defaultUnit: 'ft3/m' },
  { legacyName: 'maximumAirflowCfm', name: 'maximumAirflow', kind: 'air_flow', defaultUnit: 'ft3/m' },
  { legacyName: 'designMaxSupplyAirflowCfm', name: 'designMaxSupplyAirflow', kind: 'air_flow', defaultUnit: 'ft3/m' },
  { legacyName: 'designFlowGpm', name: 'designFlow', kind: 'liquid_flow', defaultUnit: 'gal/min' },
  { legacyName: 'designFlowCfh', name: 'designFlow', kind: 'gas_flow', defaultUnit: 'ft3/h' },
  { legacyName: 'designHeadFt', name: 'designHead', kind: 'length', defaultUnit: 'ft' },
  { legacyName: 'motorPowerHp', name: 'motorPower', kind: 'power', defaultUnit: 'hp' },
  { legacyName: 'coolingCapacityBtuh', name: 'coolingCapacity', kind: 'cooling_capacity', defaultUnit: 'BTU/h' },
  { legacyName: 'coolingCapacityTons', name: 'coolingCapacity', kind: 'cooling_capacity', defaultUnit: 'TR' },
  { legacyName: 'heatingCapacityBtuh', name: 'heatingCapacity', kind: 'heating_capacity', defaultUnit: 'BTU/h' },
  { legacyName: 'designCoolingLoadBtuh', name: 'designCoolingLoad', kind: 'cooling_capacity', defaultUnit: 'BTU/h' },
  { legacyName: 'designHeatingLoadBtuh', name: 'designHeatingLoad', kind: 'heating_capacity', defaultUnit: 'BTU/h' },
  { legacyName: 'ratedVoltageV', name: 'ratedVoltage', kind: 'potential', defaultUnit: 'V' },
  { legacyName: 'ratedAcVoltageV', name: 'ratedAcVoltage', kind: 'potential', defaultUnit: 'V' },
  { legacyName: 'ratedDcVoltageV', name: 'ratedDcVoltage', kind: 'potential', defaultUnit: 'V' },
  { legacyName: 'primaryVoltageV', name: 'primaryVoltage', kind: 'potential', defaultUnit: 'V' },
  { legacyName: 'secondaryVoltageV', name: 'secondaryVoltage', kind: 'potential', defaultUnit: 'V' },
  { legacyName: 'ratedCurrentA', name: 'ratedCurrent', kind: 'current', defaultUnit: 'A' },
  { legacyName: 'ratedPowerKw', name: 'ratedPower', kind: 'power', defaultUnit: 'kW' },
  { legacyName: 'ratedApparentPowerKva', name: 'ratedApparentPower', kind: 'apparent_power', defaultUnit: 'kV*A' },
  { legacyName: 'capacityKwh', name: 'capacity', kind: 'energy', defaultUnit: 'kWh' }
];

var MAX_FIELD_NAME_LENGTH = 63;

var SEMANTIC_KIND_UNIT_HINTS = {
  air_flow: ['ft3/m', 'ft3/h', 'm3/h', 'm3/s', 'L/s'],
  liquid_flow: ['gal/min', 'L/min', 'L/s', 'm3/h', 'm3/s'],
  gas_flow: ['ft3/h', 'm3/h', 'm3/s', 'L/s'],
  air_pressure: ['inH2O', 'Pa', 'kPa', 'mmH2O'],
  pressure: ['psi', 'Pa', 'kPa', 'bar', 'MPa', 'inH2O'],
  apparent_power: ['kV*A', 'V*A'],
  cooling_capacity: ['TR', 'BTU/h', 'kW'],
  heating_capacity: ['BTU/h', 'kW'],
  power: ['kW', 'W', 'hp', 'BTU/h'],
  energy: ['kWh', 'Wh', 'BTU'],
  temperature: ['degF', 'degC', 'tempK'],
  length: ['ft', 'm', 'in'],
  current: ['A', 'mA'],
  potential: ['V', 'kV'],
  frequency: ['Hz'],
  speed: ['ft/min', 'm/s', 'rpm'],
  time: ['min', 'h', 's'],
  volume: ['gal', 'ft3', 'L'],
  unitless: ['%']
};

function trimString(value) {
  return typeof value === 'string' ? value.trim() : '';
}

function getFieldName(field) {
  if (typeof field === 'string') return trimString(field);
  if (field && typeof field === 'object') {
    return trimString(field.name || field.fieldName);
  }
  return '';
}

function getFieldNameLengthError(field) {
  var fieldName = getFieldName(field);
  if (!fieldName || fieldName.length <= MAX_FIELD_NAME_LENGTH) return '';
  return 'Field names must be ' + MAX_FIELD_NAME_LENGTH + ' characters or fewer.';
}

function normalizeFieldDefinition(field) {
  var fieldName = getFieldName(field);
  if (!fieldName) return null;

  var normalized = { name: fieldName };
  var kind = field && typeof field === 'object' ? trimString(field.kind) : '';
  var defaultUnit = field && typeof field === 'object' ? trimString(field.defaultUnit) : '';
  var label = field && typeof field === 'object' ? trimString(field.label) : '';

  if (kind) normalized.kind = kind;
  if (defaultUnit) normalized.defaultUnit = defaultUnit;
  if (label) normalized.label = label;

  return normalized;
}

function mergeFieldDefinitions(baseField, incomingField) {
  var base = normalizeFieldDefinition(baseField) || {};
  var incoming = normalizeFieldDefinition(incomingField) || {};
  var merged = {
    name: incoming.name || base.name || ''
  };

  if (base.kind || incoming.kind) {
    merged.kind = incoming.kind || base.kind;
  }
  if (base.defaultUnit || incoming.defaultUnit) {
    merged.defaultUnit = incoming.defaultUnit || base.defaultUnit;
  }
  if (base.label || incoming.label) {
    merged.label = incoming.label || base.label;
  }

  return normalizeFieldDefinition(merged);
}

function normalizeFieldDefinitions(fields) {
  var list = [];
  if (Array.isArray(fields)) {
    list = fields.slice();
  } else if (fields && typeof fields === 'object') {
    list = Object.keys(fields).map(function (key) {
      if (fields[key] && typeof fields[key] === 'object' && !Array.isArray(fields[key])) {
        return Object.assign({ name: key }, fields[key]);
      }
      return { name: key };
    });
  }

  var byName = {};
  var orderedNames = [];

  list.forEach(function (field) {
    var normalized = normalizeFieldDefinition(field);
    if (!normalized || !normalized.name) return;
    if (!byName[normalized.name]) {
      byName[normalized.name] = normalized;
      orderedNames.push(normalized.name);
      return;
    }
    byName[normalized.name] = mergeFieldDefinitions(byName[normalized.name], normalized);
  });

  return orderedNames.map(function (name) {
    return byName[name];
  });
}

function dedupeFieldDefinitions(fields) {
  return normalizeFieldDefinitions(fields);
}

function isQuantityField(field) {
  var normalized = normalizeFieldDefinition(field);
  return Boolean(normalized && normalized.kind);
}

function hasOwnValue(record, key) {
  return Boolean(
    record &&
    Object.prototype.hasOwnProperty.call(record, key) &&
    typeof record[key] !== 'undefined'
  );
}

function isQuantityValue(value) {
  return Boolean(
    value &&
    typeof value === 'object' &&
    !Array.isArray(value) &&
    (Object.prototype.hasOwnProperty.call(value, 'value') ||
      Object.prototype.hasOwnProperty.call(value, 'unit'))
  );
}

function normalizeQuantityValue(value, fallbackUnit) {
  if (value == null) return null;

  if (isQuantityValue(value)) {
    return {
      value: Object.prototype.hasOwnProperty.call(value, 'value') ? value.value : null,
      unit: trimString(value.unit) || trimString(fallbackUnit)
    };
  }

  return {
    value: value,
    unit: trimString(fallbackUnit)
  };
}

function quantityValueHasContent(value) {
  if (!value) return false;
  if (value.value === 0) return true;
  if (typeof value.value === 'number' && !Number.isNaN(value.value)) return true;
  if (typeof value.value === 'string' && value.value.trim()) return true;
  return false;
}

function isDisplayableFieldValue(value, field) {
  if (isQuantityField(field)) {
    return quantityValueHasContent(normalizeQuantityValue(value));
  }
  if (value === 0) return true;
  if (value === false) return true;
  if (Array.isArray(value)) return value.length > 0;
  if (value && typeof value === 'object') return Object.keys(value).length > 0;
  return value != null && String(value).trim() !== '';
}

function matchesLegacyAlias(alias, field) {
  var normalized = normalizeFieldDefinition(field);
  if (!alias || !normalized) return false;
  if (alias.name !== normalized.name) return false;
  if (normalized.kind && alias.kind && alias.kind !== normalized.kind) return false;
  if (normalized.defaultUnit && alias.defaultUnit && alias.defaultUnit !== normalized.defaultUnit) {
    return false;
  }
  return true;
}

function getFieldLegacyAliases(field) {
  return LEGACY_FIELD_ALIASES.filter(function (alias) {
    return matchesLegacyAlias(alias, field);
  });
}

function getFieldStorageNames(field) {
  var normalized = normalizeFieldDefinition(field);
  if (!normalized) return [];
  var names = [normalized.name];
  getFieldLegacyAliases(normalized).forEach(function (alias) {
    if (names.indexOf(alias.legacyName) === -1) {
      names.push(alias.legacyName);
    }
  });
  return names;
}

function readEquipmentFieldValue(record, field) {
  var normalized = normalizeFieldDefinition(field);
  if (!record || !normalized || !normalized.name) {
    return {
      field: normalized || null,
      sourceName: normalized ? normalized.name : '',
      value: undefined,
      legacy: false
    };
  }

  if (hasOwnValue(record, normalized.name)) {
    return {
      field: normalized,
      sourceName: normalized.name,
      value: isQuantityField(normalized)
        ? normalizeQuantityValue(record[normalized.name], normalized.defaultUnit)
        : record[normalized.name],
      legacy: isQuantityField(normalized) && !isQuantityValue(record[normalized.name])
    };
  }

  if (isQuantityField(normalized)) {
    var aliases = getFieldLegacyAliases(normalized);
    for (var idx = 0; idx < aliases.length; idx += 1) {
      var alias = aliases[idx];
      if (!hasOwnValue(record, alias.legacyName)) continue;
      return {
        field: normalized,
        sourceName: alias.legacyName,
        value: normalizeQuantityValue(record[alias.legacyName], alias.defaultUnit || normalized.defaultUnit),
        legacy: true
      };
    }
  }

  return {
    field: normalized,
    sourceName: normalized.name,
    value: undefined,
    legacy: false
  };
}

function getEditableFieldValue(record, field) {
  var normalized = normalizeFieldDefinition(field);
  var resolved = readEquipmentFieldValue(record, normalized);
  if (!normalized) return '';
  if (!isQuantityField(normalized)) {
    return typeof resolved.value === 'undefined' ? '' : resolved.value;
  }
  var quantity = normalizeQuantityValue(resolved.value, normalized.defaultUnit) || {
    value: '',
    unit: trimString(normalized.defaultUnit)
  };
  if (quantity.value == null) {
    quantity.value = '';
  }
  if (!quantity.unit && normalized.defaultUnit) {
    quantity.unit = normalized.defaultUnit;
  }
  return quantity;
}

function formatFieldValue(value, field) {
  var normalized = normalizeFieldDefinition(field);
  if (!normalized) return '';
  if (isQuantityField(normalized)) {
    var quantity = normalizeQuantityValue(value, normalized.defaultUnit);
    if (!quantity || !quantityValueHasContent(quantity)) return '';
    if (quantity.unit) {
      return String(quantity.value) + ' ' + quantity.unit;
    }
    return String(quantity.value);
  }
  if (value == null) return '';
  if (typeof value === 'object') {
    return JSON.stringify(value);
  }
  return String(value);
}

function getDisplayFieldValue(record, field) {
  var resolved = readEquipmentFieldValue(record, field);
  return formatFieldValue(resolved.value, field);
}

function coerceNumber(value) {
  if (typeof value === 'number') return value;
  var trimmed = trimString(value);
  if (!trimmed) return '';
  var parsed = Number(trimmed);
  return Number.isFinite(parsed) ? parsed : trimmed;
}

function buildQuantityPayload(value, fallbackUnit) {
  var quantity = normalizeQuantityValue(value, fallbackUnit) || {
    value: '',
    unit: trimString(fallbackUnit)
  };
  var coercedValue = coerceNumber(quantity.value);
  if (coercedValue === '' || coercedValue == null) {
    return null;
  }
  return {
    value: coercedValue,
    unit: trimString(quantity.unit)
  };
}

function buildFieldPayload(field, value) {
  var normalized = normalizeFieldDefinition(field);
  if (!normalized) return undefined;
  if (!isQuantityField(normalized)) return value;
  return buildQuantityPayload(value, normalized.defaultUnit);
}

function normalizeUnitToken(value) {
  return trimString(value).toLowerCase();
}

function unitMatchesToken(unitRecord, token) {
  if (!unitRecord || !token) return false;
  var candidates = [unitRecord.name].concat(Array.isArray(unitRecord.aliases) ? unitRecord.aliases : []);
  return candidates.some(function (candidate) {
    return normalizeUnitToken(candidate) === token;
  });
}

function buildSyntheticUnitRecord(token, kind) {
  return {
    name: trimString(token),
    aliases: [],
    kind: trimString(kind)
  };
}

function getUnitsForKind(kind, units) {
  var normalizedKind = trimString(kind);
  if (!normalizedKind) return [];
  var unitList = Array.isArray(units) ? units.slice() : [];
  var hintTokens = SEMANTIC_KIND_UNIT_HINTS[normalizedKind];
  var seen = {};

  function pushUnique(records, unitRecord) {
    var normalizedName = normalizeUnitToken(unitRecord && unitRecord.name);
    if (!normalizedName || seen[normalizedName]) return;
    seen[normalizedName] = true;
    records.push(unitRecord);
  }

  if (hintTokens && hintTokens.length) {
    return hintTokens.reduce(function (records, token) {
      var normalizedToken = normalizeUnitToken(token);
      var matches = unitList.filter(function (unitRecord) {
        return unitMatchesToken(unitRecord, normalizedToken);
      });
      if (matches.length) {
        matches.forEach(function (unitRecord) {
          pushUnique(records, unitRecord);
        });
      } else {
        pushUnique(records, buildSyntheticUnitRecord(token, normalizedKind));
      }
      return records;
    }, []);
  }

  return unitList.filter(function (unitRecord) {
    return trimString(unitRecord && unitRecord.kind) === normalizedKind;
  });
}

function listKnownFieldKinds(kindOptions) {
  var seen = {};
  var ordered = [];

  Object.keys(SEMANTIC_KIND_UNIT_HINTS).forEach(function (kind) {
    seen[kind] = true;
    ordered.push(kind);
  });

  (Array.isArray(kindOptions) ? kindOptions : []).forEach(function (kind) {
    var trimmed = trimString(kind);
    if (!trimmed || seen[trimmed]) return;
    seen[trimmed] = true;
    ordered.push(trimmed);
  });

  return ordered.sort();
}

module.exports = {
  LEGACY_FIELD_ALIASES: cloneJson(LEGACY_FIELD_ALIASES),
  MAX_FIELD_NAME_LENGTH: MAX_FIELD_NAME_LENGTH,
  SEMANTIC_KIND_UNIT_HINTS: cloneJson(SEMANTIC_KIND_UNIT_HINTS),
  normalizeFieldDefinition: normalizeFieldDefinition,
  normalizeFieldDefinitions: normalizeFieldDefinitions,
  dedupeFieldDefinitions: dedupeFieldDefinitions,
  mergeFieldDefinitions: mergeFieldDefinitions,
  getFieldName: getFieldName,
  getFieldNameLengthError: getFieldNameLengthError,
  isQuantityField: isQuantityField,
  isQuantityValue: isQuantityValue,
  normalizeQuantityValue: normalizeQuantityValue,
  quantityValueHasContent: quantityValueHasContent,
  isDisplayableFieldValue: isDisplayableFieldValue,
  getFieldLegacyAliases: getFieldLegacyAliases,
  getFieldStorageNames: getFieldStorageNames,
  readEquipmentFieldValue: readEquipmentFieldValue,
  getEditableFieldValue: getEditableFieldValue,
  formatFieldValue: formatFieldValue,
  getDisplayFieldValue: getDisplayFieldValue,
  buildFieldPayload: buildFieldPayload,
  buildQuantityPayload: buildQuantityPayload,
  getUnitsForKind: getUnitsForKind,
  listKnownFieldKinds: listKnownFieldKinds
};
